// extracted by mini-css-extract-plugin
export default {"container":"ak-z","blurb":"bk-z","links":"ck-z"};